var _excluded = [
  "error",
  "handleChange",
  "handleFocus",
  "name",
  "label",
  "id",
  "disabled",
  "maxWidth",
  "type",
  "iconSrc",
  "iconColor",
  "iconWidth",
  "iconHeight",
  "iconLeft",
  "iconTop",
];

function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React from "react";
import { Box, FormField } from "grommet";
import { StyledTextInput, StyledFormField, StyledIconSvg, StyledBox } from "./styles";
export var TextInput = function TextInput(_ref) {
  var _ref$error = _ref.error,
    error = _ref$error === void 0 ? "" : _ref$error,
    _ref$handleChange = _ref.handleChange,
    handleChange = _ref$handleChange === void 0 ? function () {} : _ref$handleChange,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? function () {} : _ref$handleFocus,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "" : _ref$name,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? Date.now() : _ref$id,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? "406px" : _ref$maxWidth,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "text" : _ref$type,
    _ref$iconSrc = _ref.iconSrc,
    iconSrc = _ref$iconSrc === void 0 ? "" : _ref$iconSrc,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? "" : _ref$iconColor,
    _ref$iconWidth = _ref.iconWidth,
    iconWidth = _ref$iconWidth === void 0 ? "" : _ref$iconWidth,
    _ref$iconHeight = _ref.iconHeight,
    iconHeight = _ref$iconHeight === void 0 ? "" : _ref$iconHeight,
    _ref$iconLeft = _ref.iconLeft,
    iconLeft = _ref$iconLeft === void 0 ? "10px" : _ref$iconLeft,
    _ref$iconTop = _ref.iconTop,
    iconTop = _ref$iconTop === void 0 ? "14px" : _ref$iconTop,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/ React.createElement(
    Box,
    {
      flex: true,
      width: {
        max: maxWidth,
      },
    },
    /*#__PURE__*/ React.createElement(
      StyledFormField,
      {
        error: error,
        disabled: disabled,
        htmlFor: id,
      },
      error.length ? error : label
    ),
    /*#__PURE__*/ React.createElement(
      StyledBox,
      null,
      iconSrc &&
        /*#__PURE__*/ React.createElement(StyledIconSvg, {
          error: error,
          iconLeft: iconLeft,
          iconTop: iconTop,
          src: iconSrc,
          width: iconWidth,
          height: iconHeight,
          color: iconColor,
          disabled: disabled,
        }),
      /*#__PURE__*/ React.createElement(
        StyledTextInput,
        _extends(
          {
            id: id,
            error: error,
            type: type,
            onFocus: handleFocus,
            onChange: handleChange,
            disabled: disabled,
            autoComplete: "off",
            name: name,
            plain: true,
            textAlign: "start",
            focusIndicator: true,
          },
          rest
        )
      )
    )
  );
};
